import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CXIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CX" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#4141DB"
        fillRule="evenodd"
        d="m0 0 16 12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        fillRule="evenodd"
        d="m3 4.5-.5.366.067-.616L2 4l.567-.25-.067-.616.5.366.5-.366-.067.616L4 4l-.567.25.067.616L3 4.5ZM2 7.5l-.5.366.067-.616L1 7l.567-.25-.067-.616.5.366.5-.366-.067.616L3 7l-.567.25.067.616L2 7.5ZM4 10.5l-.5.366.067-.616L3 10l.567-.25-.067-.616.5.366.5-.366-.067.616L5 10l-.567.25.067.616L4 10.5ZM4.5 5.75l-.25.183.033-.308L4 5.5l.283-.125-.033-.308.25.183.25-.183-.033.308L5 5.5l-.283.125.033.308-.25-.183Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M10.78 6.112c-.186-.195 1.496-.653 1.67-1.244.231-.514.077-.931-.796-1.297-.873-.366-1.756-1.074-.741-1.074 1.014 0 1.014.145 1.287.572.273.426.862.518.874 0 0-.883.084-1.002-.63-1.77-.712-.767 1.788.316 1.581 1.631-.206 1.316-.455.892-.297 1.113.158.22 1.108-.465.99.448-.333.526-.992 1.307-3.937 1.621Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M8 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
        clipRule="evenodd"
      />
      <Path
        fill="#548650"
        fillRule="evenodd"
        d="M6.477 5.081c.283-.063.67.696 1.37.411.7-.284.847-.828 1.18-.63.332.2.375.679.154.92-.222.24-.597.298-.597.602s-.074 1.39-.218 1.075c-.43-.35-.168-.906-.698-1.075-.531-.169-.853-.163-1.245-.092-.391.071.263-.196.402-.45.283-.271-.478-.67-.348-.76Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
